import { InjectionToken } from '@angular/core';
import { Config } from '@modeso/modeso-lib-core-fe';

export interface ModesoAddressConfig extends Config {
    serviceId: string;
}

export const ModesoAddressConfigService = new InjectionToken<ModesoAddressConfig>('Config');
